export const APP_SELECTOR = 'pwc-mpp-esp-app';
export const APP_INPUT_ORIGIN = 'origin';
export const APP_INPUT_BASEHREF = 'basehref';
